import React from 'react';
import { Reveal } from './Reveal';
const bonuses = [{
  image: 'https://cdn.magicpatterns.com/uploads/5v2VxkGcwocVJvGjhyjWoD/Bono_1_musica.webp',
  title: 'Banco de Canciones',
  description: 'Repertorio listo para usar en cada clase',
  price: '$39.000',
  badge: 'bg-brand-blue'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/iqQnFEDdXKGGsCaAp4SWNy/Bono_2_musica.webp',
  title: 'Instrumentos Reciclados',
  description: 'Guía para crear instrumentos con materiales reciclados',
  price: '$30.500',
  badge: 'bg-brand-green'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/gY34RcE5bC2abFkFzBujEn/Bono_3_musica.webp',
  title: 'Plantillas de Evaluación',
  description: 'Evaluaciones listas por nivel y contenido',
  price: '$28.500',
  badge: 'bg-brand-purple'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/tN4FSURG4xJQzWLwx2Y6tm/Bono_4_musica.webp',
  title: 'Rúbricas de Coevaluación',
  description: 'Para trabajos grupales entre alumnos',
  price: '$28.500',
  badge: 'bg-brand-pink'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/riWL4hYgy3uMA5Ed748SZC/bono_5_musica.webp',
  title: 'Calendario Anual + Planificador de Clases',
  description: 'Organización completa del ciclo lectivo',
  price: '$37.000',
  badge: 'bg-brand-orange'
}];
export function BonusesSection() {
  return <section className="bg-brand-dark px-4 py-20 md:py-28" data-id="element-17" data-mp="ckbmutnxxv08">
      <Reveal className="mx-auto max-w-3xl" data-id="element-18" data-mp="chpfau11vfi0">
        <div className="mb-12 text-center" data-id="element-19" data-mp="gklsu6bqglf3">
          <div className="inline-flex rounded-full bg-brand-orange px-4 py-2 text-[10px] font-extrabold tracking-[0.14em] text-white" data-id="element-20" data-mp="gjkjc6ad86zh">
            VALORADO EN MÁS DE $158.000
          </div>
          <h2 className="mt-4 text-3xl font-black text-brand-blue md:text-4xl" data-id="element-21" data-mp="qaoron5jctlc">
            🎁 5 Bonos Exclusivos
          </h2>
          <p className="mt-4 text-brand-gray" data-id="element-22" data-mp="v8gonvl1f5we">Incluidos sin costo adicional al llevar el pack hoy.</p>
        </div>
        <div className="space-y-3" data-id="element-23" data-mp="akz6s2lmv4lt">
          {bonuses.map(({
          image,
          title,
          description,
          price,
          badge
        }, index) => <article key={title} className="flex items-center gap-4 rounded-2xl border border-brand-blue/[0.06] bg-brand-alt p-4 shadow-sm sm:gap-5" data-id="element-24" data-mp="5mxfiue1zyz9" data-mpi={index}>
              <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full font-serif font-bold text-white ${badge}`} data-id="element-25" data-mp="fjse1dabtzdj">
                {index + 1}
              </span>
              <img src={image} alt={`Portada del bono ${title}`} className="h-20 w-16 shrink-0 rounded-lg border border-brand-dark object-cover shadow-sm sm:h-24 sm:w-[4.5rem]" data-id="element-26" data-mp="obly39p2ds7v" />
              <div className="min-w-0 flex-1" data-id="element-27" data-mp="y8ywr0b4eqzc">
                <h3 className="font-bold leading-snug text-brand-blue" data-id="element-28" data-mp="352asy0vk05bz">{title}</h3>
                <p className="mt-1 text-xs" data-id="element-29" data-mp="302ps1kwtpmwm">
                  <span className="text-brand-gray" data-id="element-30" data-mp="3040wlmy3eyos">{description}</span>
                  <span className="ml-2 font-semibold text-brand-purple line-through" data-id="element-31" data-mp="1fl6x2i2lisb6">
                    valor {price}
                  </span>
                  <span className="ml-2 font-extrabold text-brand-green" data-id="element-32" data-mp="1kl1msiamxbun">GRATIS</span>
                </p>
              </div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}